import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles/Help'

const Help = ({
  hasPlum,
  hasReviews,
  onlyVars,
  pmsType,
  pmsVersion,
}) => {
  let variables = [
    'patient_first_name',
    'patient_last_name',
    'patient_full_name',
    'patient_preferred_name',
    'practice_name',
    'location_name',
    'location_street_address',
    'location_secondary_address',
    'location_city',
    'location_state',
    'location_zip',
    'location_phone_number',
    'appointment_time',
    'appointment_date',
    'website',
  ]
  if (pmsType !== 'OrthoTrac') {
    variables = [
      ...variables,
      'doctor_first_name',
      'doctor_last_name',
      'doctor_full_name',
    ]
  }
  if (hasReviews) {
    variables = [
      ...variables,
      'location_facebook_url',
      'location_google_url',
      'location_yelp_url',
    ]
  }
  if (hasPlum) {
    variables = [
      ...variables,
      'plum_appt_url',
    ]
  }
  if (pmsType === 'topsOrtho' && pmsVersion && pmsVersion < 6) {
    variables.splice(3, 1) // To remove the 'patient_preferred_name' field
  }
  return (
    <div style={styles.helpWrapper}>
      {!onlyVars && (
        <div>
          <h6 style={styles.helpHeader}>To schedule a message:</h6>
          <table>
            <tbody>
              <tr>
                <td style={Object.assign({}, styles.stepNumber, styles.td1)}>1</td>
                <td style={styles.td}>Click the plus button next to the event type (first appointment, next appointment, missed appointment, recall) and select a blank message type.</td>
                <td style={Object.assign({}, styles.stepNumber, styles.td2)}>2</td>
                <td style={styles.td}>Drag the message to the desired day/time on the timeline.</td>
                <td style={Object.assign({}, styles.stepNumber, styles.td3)}>3</td>
                <td style={styles.td}>Complete the form and click save.</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      <p style={styles.variablesHeader}>Variables:</p>
      <div style={styles.variablesContainer}>
        {variables.map(variable => (
          <div key={variable} style={styles.variableItem}>• {variable}</div>
        ))}
      </div>
    </div>
  )
}

Help.propTypes = {
  hasPlum: PropTypes.bool.isRequired,
  hasReviews: PropTypes.bool.isRequired,
  onlyVars: PropTypes.bool.isRequired,
  pmsType: PropTypes.string,
  pmsVersion: PropTypes.number,
}

export default Help



// WEBPACK FOOTER //
// ./src/components/Settings/Help.js